module.exports = __webpack_public_path__ + "media/images/ui-images/image-rounded-fd0393e7bbfd0dc9fff767ccf8135007.jpg";